import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useCallback, useEffect, useState, createContext, useContext } from 'react'
import { api } from '../../../../../services/api'
import moment from 'moment'


const FilteredContext = createContext();


export const FilteredProvider = ({ children }) => {
    const { 
        listBusinessToFilter, 
        listAllBusinessCodes, 
        startDate, 
        endDate 
    } = useAdministrativeContext()

    const [outdatedBusiness, setOutdatedBusiness] = useState({})
    const [additionalInfo, setAdditionalInfo] = useState('')
    const [atLeastTwo, setAtLeastTwo] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [openFiltersDetailed, setOpenFiltersDetailed] = useState(false)
   

    function isFilteringSingleBusiness(businessLenght) {
        if(businessLenght === 1)
            return 'filtering single'
        
        return 'filtering at least two'
    }

    const checkingInfoToFetchData = useCallback(() => {
        let businessLength = listBusinessToFilter.length

        if(businessLength === listAllBusinessCodes.length)
            return 'filtering all'

        return isFilteringSingleBusiness(businessLength)
    }, [listAllBusinessCodes, listBusinessToFilter])
    
    const openingFiltersDetailed = useCallback(() => {
        setOpenFiltersDetailed(state => !state)
    }, [])

    function atLeastTwoText(regions) {
        const regionsLength = regions.length - 1 > 0

        return `${regions[0].region} ${regionsLength ? `+${regions.length - 1}`: ''}`
    }

    let whatsIsFiltering = checkingInfoToFetchData()

    
    useEffect(() => {
        async function fetchData() {
            setIsLoading(true)

            await api.get(`/getFilteredInformations/?business=${listBusinessToFilter}&currentLength=${whatsIsFiltering}`)
                .then(response => {
                    setOutdatedBusiness({
                        lastSync: moment(response.data.outdatedBusiness.lastSync.slice(0, 16)).format('DD/MM/YYYY HH:mm'),
                        name: response.data.outdatedBusiness.name,
                        city: response.data.outdatedBusiness.city,
                        state: response.data.outdatedBusiness.state
                    })

                    if(whatsIsFiltering === 'filtering at least two')
                        setAtLeastTwo(response.data.filters)
                    else{
                        setAdditionalInfo(response.data.filters)
                        setAtLeastTwo([])
                    }
                })
            
            setIsLoading(false)
        }
        
        fetchData()
    }, [listBusinessToFilter, whatsIsFiltering])


    useEffect(() => {
        if(!atLeastTwo.length){
            setOpenFiltersDetailed(false)
        }
    }, [atLeastTwo])


    return (
        <FilteredContext.Provider value={{ 
            startDate, 
            endDate,
            outdatedBusiness,
            additionalInfo,
            atLeastTwo,
            isLoading,
            atLeastTwoText,
            openFiltersDetailed, 
            openingFiltersDetailed
        }}>
            {children}
        </FilteredContext.Provider>
    );
}


export function useFiltered() {
    const context = useContext(FilteredContext);

    if(!context) {
        throw new Error('useFiltered must be used within an Provider');
    }

    return context;
}
